// src/components/jobDetails/RunSelector.jsx
export default function RunSelector({ runs, selectedRun, onRunChange, onNewRun }) {
  return (
    <div className="flex items-center gap-2">
      <select
        value={selectedRun || ""}
        onChange={(e) => onRunChange(Number(e.target.value))}
        className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {runs.map((run) => (
          <option key={run.id} value={run.id}>
            Run #{run.run_number} ({run.survey_from}m - {run.survey_to}m)
          </option>
        ))}
      </select>
      <button
        onClick={onNewRun}
        className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md text-sm"
      >
        + New Run
      </button>
    </div>
  );
}